enum ManufactureTypeEnum {
    Milling = 'milling',
    Print = 'print',
    Fdm = 'fdm',
    All = 'all',
}

export default ManufactureTypeEnum;
